import React from 'react'
import { withTranslationCustom } from 'lib/i18next'
import classNames from 'classnames'
import { intersection } from 'lodash'

import { isTouchSupport } from 'lib/helpers'

import Icon from 'components/Icon'
import Button from 'components/UI/Button'

import './context-actions-select.pcss'

class ContextActionsSelect extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isOpen: false
        }

        this.clickEvent = 'mouseup'
        this.touchEvent = isTouchSupport() ? 'touchend' : ''
    }

    componentDidMount () {
        document.addEventListener(this.clickEvent, this.handleClick, false)
        if (this.touchEvent) {
            document.addEventListener(this.touchEvent, this.handleClick, false)
        }
    }

    componentWillUnmount () {
        document.removeEventListener(this.clickEvent, this.handleClick, false)
        if (this.touchEvent) {
            document.removeEventListener(this.touchEvent, this.handleClick, false)
        }
    }

    handleClick = (e) => {
        if (!this.state.isOpen) return
        if (!this.node || this.node.contains(e.target)) return

        this.setState({ isOpen: false })
    }

    toggleLinks (e, preventCloseOn) {
        if (e.target && intersection(e.target.classList, preventCloseOn).length) return

        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    renderChevron = (chevronProps) => {
        return this.state.isOpen ? (
            <Icon
                name="icon_chevron_up_white"
                size="m"
                {...this.props.chevronProps}
                {...chevronProps}
            />
        ) : (
            <Icon
                name="icon_chevron_down_white"
                size="m"
                {...this.props.chevronProps}
                {...chevronProps}
            />
        )
    }

    render () {
        const {
            text,
            cta,
            cssClass,
            children,
            renderCustomButton,
            renderChevron,
            preventCloseOn,
            trackName,
            alignRight,
            buttonClassName,
            dataTestId,
        } = this.props

        return (
// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <nav
                data-testid={dataTestId}
                ref={(node) => { this.node = node }}
                className={classNames(
                    'context-actions-select',
                    'action',
                    { [cssClass]: cssClass },
                    { 'context-actions-select--active': this.state.isOpen },
                    { 'context-actions-select--align-right': alignRight },
                )}
                onClick={(e) => this.toggleLinks(e, preventCloseOn)}
                onKeyPress={(e) => this.toggleLinks(e, preventCloseOn)}
            >
                <div className="context-actions-select__wrapper">
                    {renderCustomButton ? (
                        <div className="context-actions-select__custom-button">
                            {renderCustomButton({ ...this.state, renderChevron: this.renderChevron })}
                        </div>
                    ) : (
                        <Button
                            className={classNames(
                                { 'context-actions-select__cta': cta },
                                buttonClassName,
                            )}
                            trackName={trackName || 'contextActionButton'}
                        >
                            {text}
                        </Button>
                    )}
                    {this.state.isOpen && (
                        <div className="context-actions-select__actions-wrapper">
                            <div className="context-actions-select__actions animated fadeInDown fastest">
                                {children}
                            </div>
                        </div>
                    )}
                    {renderChevron && (
                        <div className="context-actions-select__chevron">
                            {this.renderChevron()}
                        </div>
                    )}
                </div>
            </nav>
        )
    }
}

export default withTranslationCustom('vehicles')(ContextActionsSelect)
